import { defineMessages } from "react-intl";
const messages = defineMessages({
    signOut: {
        id: "app.sidebar.signOut.text",
        defaultMessage: "Sign Out",
    },
    home: {
        id: "app.sidebar.home.text",
        defaultMessage: "Home",
    },
    spaces: {
        id: "app.sidebar.virtualTours.text",
        defaultMessage: "Virtual Tours",
    },
    scanRequests: {
        id: "app.sidebar.scanRequests.text",
        defaultMessage: "Scan Requests",
    },
    prospectIntelligence: {
        id: "app.sidebar.prospectIntelligence.text",
        defaultMessage: "Prospects",
    },
    analytics: {
        id: "app.sidebar.analytics.text",
        defaultMessage: "Analytics",
    },
    accountHealth: {
        id: "app.sidebar.accountHealth.text",
        defaultMessage: "Account Health",
    },
    dedupeUnits: {
        id: "app.sidebar.dedupeUnits.text",
        defaultMessage: "Dedupe Units",
    },
    users: {
        id: "app.sidebar.users.text",
        defaultMessage: "Users",
    },
    sgt: {
        id: "app.sidebar.sgt.text",
        defaultMessage: "Self-Guided Tours",
    },
    settings: {
        id: "app.sidebar.settings.text",
        defaultMessage: "Settings",
    },
    helpDesk: {
        id: "app.sidebar.helpDesk.text",
        defaultMessage: "Help Desk",
    },
    contentServices: {
        id: "app.sidebar.contentServices.text",
        defaultMessage: "Content Services",
    },
    aiDiscoverability: {
        id: "app.sidebar.aiDiscoverability.text",
        defaultMessage: "AI Discoverability",
    },
});
export default messages;
